import Step1_Language from "../components/Wizard/Step1_Language";

export default function WizardPage() {
  return <Step1_Language />;
}